/* eslint max-len:0 */
import React from 'react'
import { ToastContainer } from 'react-toastify'

import { ErrorBoundary } from '@duplo/utils/lib/errorTracking'

import 'react-toastify/dist/ReactToastify.min.css'

const TemplateWrapper = ({ children }) => {
	const templateContents = (
		<div>
			<ToastContainer />
			{children}
		</div>
	)

	// if we're in the client and can render the error boundry wrap everything in it.
	if (ErrorBoundary) {
		return <ErrorBoundary>{templateContents}</ErrorBoundary>
	}

	return templateContents
}

export default TemplateWrapper
